"use client";
import React from "react";
import StickyScrolls from "../../ui/StickyRolls";
import image1 from '../../assets/images/image1.webp'
import image2 from '../../assets/images/image2.jpg'
const content = [
  {
    title: "Book a demo!",
    description:
      "Unlock the power of reading! 🎉 Book a free demo class in Phonics and watch your child learn sounds, blend words, and read with confidence.",
    content:image1
  },
  {
    title: "Book Your Phonics Demo Class Today!",
    description:
      "Our playful teaching methods make learning exciting, while helping your child gain confidence in reading and speaking. Watch them explore letters, sounds, and stories with joy. Reserve your free demo spot today and take the first step toward strong language skills!",
    content:image2
  },
];
export function HowItsWorks() {
  return (
    <div className="w-full py-4">
      <StickyScrolls content={content} />
    </div>
  );
}
